import { isNullOrUndefined } from "url/util";

/**
   * Verifies if the user with the current email address is an admin.
   * @author Lewis Harman
   * @version 1.0.0
   * @since 2025-04-07
   * @param {string} emailAddress The email address of a user.
   * @returns {boolean} True if they're an admin. False otherwise.
   * @example
   *  >>> async function main() {
   *  ...   const userEmailAddress = "test@example.com";
   *  ...   const userIsAdmin = isAdmin(userEmailAddress);
   *  ...   console.log("User is an admin? " + userIsAdmin)
   *  ... }
   *  ... main();
   */
export default function isAdmin(emailAddress) {

  if (isNullOrUndefined(emailAddress)) {
    return false;
  }

  else if (emailAddress.trim().endsWith("@performance-edge.co.uk")) {
    return true;
  }

  else if (["lewis-harman@outlook.com", "ethanwaboyd@gmail.com"].includes(emailAddress.trim())) {
    return true;
  }

  return false;

}